module.exports = __webpack_public_path__ + "img/10.8.TSS.28a3bb2a.png";